import { RefObject } from "react";
import { react } from "uikit";

import { PaymentProvider } from "../../../../../../../../../services/PaymentSystem";
import {
	CompanyAndTaxiService,
	EasyPayPayment,
	OtvPayment,
	Name,
	RefundPolicy,
	SelectPaymentSystems,
} from "../../../../../components";

interface Context {
	refundPolicyRef: RefObject<RefundPolicy.Ref | null>;
	nameRef: RefObject<Name.Ref | null>;
	companyBranchRef: RefObject<CompanyAndTaxiService.Ref | null>;
	paymentSystemRef: RefObject<SelectPaymentSystems.Ref | null>;
	paymentProviderValue: PaymentProvider;
	easyPayPaymentRef: RefObject<EasyPayPayment.Ref | null>;
	otvPaymentRef: RefObject<OtvPayment.Ref | null>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isRefundPolicyValid =
			this.context?.refundPolicyRef.current?.validate() ?? true;
		const isBaseValid = this.validateBase();

		return isRefundPolicyValid && isBaseValid;
	}

	private validateBase() {
		const isNameValid = !!this.context?.nameRef.current?.validate();
		const isBranchesValid =
			!!this.context?.companyBranchRef.current?.validate();
		const isPaymentSystemValid =
			!!this.context?.paymentSystemRef.current?.validate();

		const paymentProviderValue = this.context?.paymentProviderValue;

		const isValid = [
			isNameValid,
			isBranchesValid,
			isPaymentSystemValid,
			!!paymentProviderValue,
		];

		if (paymentProviderValue === PaymentProvider.EASYPAY) {
			isValid.push(
				!!this.context?.easyPayPaymentRef.current?.validate(),
			);
			return isValid.every(Boolean);
		}

		if (paymentProviderValue === PaymentProvider.OTV) {
			isValid.push(!!this.context?.otvPaymentRef.current?.validate());
			return isValid.every(Boolean);
		}

		return false;
	}
}
